import { getToken } from './LocalStorageService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const getAuthHeaders = () => {
    const { access_token } = getToken();
    return {
        'Content-Type': 'application/json',
        'Authorization': access_token ? `Bearer ${access_token}` : ''
    };
};

const FacultyService = {
    async getAllFaculty(params = {}) {
        const queryString = new URLSearchParams(params).toString();
        const response = await fetch(`${API_BASE_URL}/faculty${queryString ? `?${queryString}` : ''}`, {
            method: 'GET',
            headers: getAuthHeaders()
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || error.message || `Failed to fetch faculty list (${response.status})`);
        }

        const resData = await response.json();
        return resData.data;
    },

    async getPublicFacultyByDepartment(departmentId) {
        const response = await fetch(`${API_BASE_URL}/faculty/public/${departmentId}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || error.message || 'Failed to fetch department faculty');
        }

        const resData = await response.json();
        return resData.data;
    },

    async createFaculty(data) {
        const response = await fetch(`${API_BASE_URL}/faculty`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || error.message || `Failed to create faculty member (${response.status})`);
        }

        const resData = await response.json();
        return resData.data;
    },

    async updateFaculty(id, data) {
        const response = await fetch(`${API_BASE_URL}/faculty/${id}`, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || error.message || `Failed to update faculty member (${response.status})`);
        }

        const resData = await response.json();
        return resData.data;
    },

    async deleteFaculty(id) {
        const response = await fetch(`${API_BASE_URL}/faculty/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || error.message || 'Failed to delete faculty member');
        }

        return true;
    },

    async bulkUpload(formData) {
        const { access_token } = getToken();
        const response = await fetch(`${API_BASE_URL}/faculty/bulk-upload`, {
            method: 'POST',
            headers: {
                'Authorization': access_token ? `Bearer ${access_token}` : ''
            },
            body: formData
        });

        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.error || error.message || 'Failed to bulk upload faculty');
        }

        return await response.json();
    },

    async reorderFaculty(orders) {
        const response = await fetch(`${API_BASE_URL}/faculty/reorder`, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify({ orders })
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || error.message || 'Failed to reorder faculty');
        }

        return await response.json();
    }
};

export default FacultyService;
